export interface SelectedJobsRequest  {
  id: string;
  jobNumber: string;
  vehicleType:number; 
  startAddress: string;
  endAddress: string;
  startTime: string;
  endTime: string;
  startLatitude: string;
  startLongitude: string;
  endLatitude: string;
  endLongitude: string;
  distance: number;
  duration: string;
  planId: string;
  capacityType1: number;
  capacityType2: number;
  capacityType3: number;
  qualifications: string;
  createdAt: string;
}
